module.exports = __webpack_public_path__ + "static/media/logo-dark.9a03c661.svg";